import { Link } from 'react-router-dom'; // Assumes react-router-dom usage
import { ArrowRight } from 'lucide-react';
import CapabilitiesGrid from './CapabilitiesGrid';
import './Hero.css';

function Hero() {
  const bgImageUrl = "images/hero.webp";

  return (
    <main className="noise-grid relative min-h-[580px] lg:min-h-[720px] flex flex-col justify-between overflow-visible">
      {/* 1. Background image moved to inline style while keeping gradient layering */}
      <div 
        className="hero-bg-layer" 
        style={{
          backgroundImage: `linear-gradient(rgba(1, 7, 20, 0.45), rgba(0, 0, 0, 0.75)), url('${bgImageUrl}')`
        }}
      />

      <div className="bridge-overlay" />

      <div className="relative max-w-7xl mx-auto w-full px-6 lg:px-12 pt-16 lg:pt-28 z-10">
        <h1 className="text-white font-display text-4xl sm:text-6xl lg:text-6xl font-bold tracking-tight max-w-3xl leading-tight">
          Engineered for <span className="font-semibold">Reliable Connections</span>
        </h1>

        <p className="text-gray-300 text-xl sm:text-xl lg:text-4xl mt-4 max-w-2xl font-normal">
          Built for lasting performance.
        </p>

        <div className="mt-8 flex flex-wrap gap-4">
          {/* 2. Replaced button with a React Router Link to /about */}
          <Link
            to="/contact"
            className="bg-cyan-400 text-cogInk font-semibold px-6 py-3 rounded-full flex items-center space-x-2 shadow-lg shadow-glow hover:bg-cyan-300 transition-all duration-300 transform hover:-translate-y-0.5 text-m sm:text-base decoration-none"
          >
            <span>Lets Connect</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>

      <CapabilitiesGrid />
    </main>
  );
}

export default Hero;